import React, { ClipboardEventHandler, PropsWithChildren } from 'react';
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum ContentParagraphModifier {
  MARGIN_BOTTOM = 'content-paragraph--margin-bottom',
  PADDING = 'content-paragraph--padding',
  WIDGET_PADDING = 'content-paragraph--widget-padding',
  TOP_HEADLINE = 'content-paragraph--top-headline',
  BOLD = 'content-paragraph--bold',
  FLEX = 'content-paragraph--flex',
}

type ContentParagraphProps = PropsWithChildren<{
  modifier?: Modifier<ContentParagraphModifier>;
  onCopy?: ClipboardEventHandler<HTMLParagraphElement>;
}>;

export function ContentParagraph({ children, modifier, onCopy }: ContentParagraphProps) {
  if (children) {
    return (
      <p className={extendClassNameWithModifier('content-paragraph', modifier)} onCopy={onCopy}>
        {children}
      </p>
    );
  }

  return null;
}
